/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Order } from './Order.js';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
} from './Order.js';

/**
 * 
 * @export
 * @interface GetOrderResponse
 */
export interface GetOrderResponse {
    /**
     * 
     * @type {Order}
     * @memberof GetOrderResponse
     */
    data?: Order;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetOrderResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetOrderResponse interface.
 */
export function instanceOfGetOrderResponse(value: object): boolean {
    return true;
}

export function GetOrderResponseFromJSON(json: any): GetOrderResponse {
    return GetOrderResponseFromJSONTyped(json, false);
}

export function GetOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OrderFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetOrderResponseToJSON(value?: GetOrderResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': OrderToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

